import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';

import { collapseSections, setLocationsInfo } from '../../../state/actions/app'
import { setCopyrightLicense, setElementToExclude, setExclusionToRemove, setLicenseToFix, setPerformedMultiLicenseExclusion } from '../../../state/actions/exclusions'

import LegalView from "./legal"
import StandardView from "./standard"
import DownloadLicensesCSV from './DownloadLicensesCsv';

const mapStateAsProps = state => ({
	isAccountDefault: state.projectInfo.titleState.isAccountDefault,
	isUserAdmin: state.projectInfo.titleState.isUserAccountAdmin,
	exclusions: state.projectInfo.exclusions,
	summary: state.projectInfo.report.licensing,
	displayLicenses: state.projectInfo.titleState.hasSbom || state.projectInfo.titleState.hasLicenses,
	displayActions: (!state.projectInfo.titleState.hasSbom || state.projectInfo.titleState.hasLicenses) && !state.projectInfo.projectInfo.readonly && state.projectInfo.isLatestReport,
	displayTeaser: state.projectInfo.titleState.isAccountOpensource,
	isLatest: state.projectInfo.isLatestReport,
	collapsed: state.summariesState.licensing,
	licensing: state.projectInfo.licensing,
	isPublic: state.projectInfo.titleState.isPublic
})

const mapDispatchAsProps = dispatch => ({
	newMitigations: (reason, newMitigation, isGlobalExclusionAvailable, isMultiple) => dispatch(setElementToExclude(reason, newMitigation, isGlobalExclusionAvailable, isMultiple)),
	removeMitigation: (advice, isGlobalExclusionAvailable) => dispatch(setExclusionToRemove(advice, isGlobalExclusionAvailable)),
	setLicenseToFix: (library) => dispatch(setLicenseToFix(library)),
	collapse: (current) => dispatch(collapseSections("licensing", current)),
	setCopyrightLicense: (library) => dispatch(setCopyrightLicense(library)),
	setPerformedMultiLicenseExclusion: (value) => dispatch(setPerformedMultiLicenseExclusion(value)),
	setLocationsInfo: (library) => dispatch(setLocationsInfo(library))
})


class Licensing extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			error: false,
			legal: false,
			legalLicenses: [],
			ready: false,
			sortByRisk: false,
			selectedSummaryLicenses: []
		}
		this.librariesData = {};
		this.removeData = {};
		this.renderId = "";
		this.update = true;
	}

	switchMode = () => {
		this.setState({ legal: this.state.legal ? false : true })
	}

	doSort() {
		for (let i = 0; i < this.props.licensing.section.standard.length; i++) {
			this.props.licensing.section.standard[i].results.sort((a, b) => {
				if (this.state.sortByRisk) {
					if (a.violations.length && !a.exclusions.length) return -1
					if (b.violations.length && !b.exclusions.length) return 1
					if (a.warnings.length && !a.exclusions.length) return -1
					if (b.warnings.length && !b.exclusions.length) return 1
					if (a.exclusions.length) return -1
					if (b.exclusions.length) return 1
					return 1
				}
				else {
					return a.library.name < b.library.name ? -1 : 1
				}
			})
		}
		this.renderId = window.randomUuid();
		this.setState({
			ready: false
		}, () => {
			this.setState({ ready: true })
		})
	}

	switchSort() {
		this.renderId = window.randomUuid();
		this.setState({ sortByRisk: !this.state.sortByRisk }, () => {

			this.doSort()
		})
	}
	getSnapshotBeforeUpdate(prevProps) {


		const hasSummaryChanged = JSON.stringify(prevProps.summary) !== JSON.stringify(this.props.summary);
		const haveExclusionsChanged = JSON.stringify(prevProps.exclusions) !== JSON.stringify(this.props.exclusions);
		return hasSummaryChanged || haveExclusionsChanged
	}
	componentDidUpdate(prevProps, prevState, didUpdate) {
		if (didUpdate) {
			this.setState({ ready: false }, () => {
				this.setState({ ready: true })
			})
		}
	}
	generateSummaryData() {
		const LanguageEntries = ({ entry }) => {

			const sortedEntries = entry.slice()

			sortedEntries.sort((a, b) => {
				if (a.violations.length) return -1
				if (b.violations.length) return 1
				if (a.warnings.length) return -1
				if (b.warnings.length) return 1
				return 0
			})

			const clickThrough = () => {
				this.props.collapse(true)
			}

			const selectLicense = (e, component, isSelected) => {
				if(!isSelected) {
					const libraryData = { domain: "licensing", content: {kind: "library", library: component.library, version: component.version, reason: "mitigated"}  }
					this.setState({ selectedSummaryLicenses: [...this.state.selectedSummaryLicenses, libraryData]})
					return
				} 
				this.state.selectedSummaryLicenses.some(({content}, i) => {
					if(content.library.name === component.library.name && content.version === component.version) {
						const selectedLicenses = this.state.selectedSummaryLicenses
						const updatedSelectedLicenses = [...selectedLicenses.slice(0,i), ...selectedLicenses.slice(i+1, selectedLicenses.length)]
						this.setState({ selectedSummaryLicenses: updatedSelectedLicenses})

					}
				})				
			}
			return sortedEntries.map(component => {
				const isSelected = this.state.selectedSummaryLicenses.some(({content}) => content.library.name === component.library.name && content.version === component.version)
				return (
					<tr key={component.library.name + component.library.version + "licensing-summary"}>
						{!this.props.isPublic ? <td className='d-flex align-items-center'>
							<i data-select-license={component.library.name+":"+component.version} className={`mr-2 pointer ${!isSelected ? "fa-regular fa-square": "fa-solid fa-square-check"}`} 
							onClick={(e) => selectLicense(e, component, isSelected)}
							></i>
							<a href={"#licensing-" + component.library.name + component.version} onClick={clickThrough}>{component.library.name}</a>
						</td> : null}
						<td>{component.version || "--"}</td>
						<td className="text-center">{component.violations.length ? <i className="fas fa-check" style={{ color: "red" }}></i> : ""}</td>
						<td className="text-center">{component.warnings.length ? <i className="fas fa-check" style={{ color: "orange" }}></i> : ""}</td>
					</tr>
				)
			})

		}

		const SummaryTable = () => {
			const performedMultiLicenseExclusion = useSelector((state) => state.multiLicenseExclusionProgress.performedMultiLicenseExclusion)
			const hiddenLanguages = useSelector((state) => state.languagesFilter.toggledLanguages)
			const reports = this.props.licensing.section.standard.slice()
			reports.map((current) => {
				current.empty = current.warningsCount === 0 && current.violationsCount === 0
				return true
			})

			reports.sort((a, b) => {
				if (a.empty) return 1
				if (b.empty) return 1
				return 0
			})

			if(performedMultiLicenseExclusion) {
				this.props.setPerformedMultiLicenseExclusion(false)
				this.setState({selectedSummaryLicenses: []})
			}


			return reports.map(({ language, results, empty }) => {
				const resultsWithWarningsOrViolations = results.filter((result) => (result.warnings.length || result.violations.length) && !result.exclusions.length)
				const allIsSelected = resultsWithWarningsOrViolations.length === this.state.selectedSummaryLicenses.filter(({content}) => content.library.language === language).length
				const selectAll = () => {
					const selectedLicenses = resultsWithWarningsOrViolations.map((component) => {
						return { domain: "licensing", content: {kind: "library", library: component.library, version: component.version, reason: "mitigated"}}
					})
					this.setState({selectedSummaryLicenses: [...this.state.selectedSummaryLicenses.filter(({content}) => content.library.language !== language), ...selectedLicenses]})
				}
				const unSelectAll = () => {
					const selectedLicenses = this.state.selectedSummaryLicenses.filter(({content}) => content.library.language !== language)
					this.setState({selectedSummaryLicenses: selectedLicenses})
				}
				if(hiddenLanguages.includes(language)) return
				return (
					<div className="col-lg-12 mb-3" key={language + "-licensing-summary"}>
						<div className='d-flex  align-items-center justify-between'>
							<p className="mt-2 mb-1"><b>{language}</b></p>
						</div>
						<React.Fragment>
							{empty || !resultsWithWarningsOrViolations.length?
								<p className="w-100 m-2 text-center">No issues detected</p> :
								<>
									<table className="summary-table table table-condensed mb-0 ">
										<thead>
											<tr>
												<th width="55%">
													{ resultsWithWarningsOrViolations.length && !this.props.isPublic?
														<i className={`mr-2 pointer ${allIsSelected ? "fa-solid fa-square-check" :"fa-regular fa-square"} `}
														onClick={() => allIsSelected ? unSelectAll() : selectAll()}></i> 
														:null
													}
													Name
												</th>
												<th width="15%">Version</th>
												<th width="15%" className="text-center">Forbidden license</th>
												<th width="15%" className="text-center">License not found</th>
											</tr>
										</thead>
										<tbody>
											<LanguageEntries entry={resultsWithWarningsOrViolations} />
										</tbody>
									</table>
								</>
							}

						</React.Fragment>

					</div>
				)
			})
		}

		return (
			<div className="report-box-body" id="licensing-summary">
				{SummaryTable()}
			</div>
		)
	}









	componentDidMount() {
		if (this.props.licensing)
			this.setState({ ready: true })
	}

	showError() {
		return (
			<div className="report-box" id="error-versions">
				<div className="report-box-header red">
					<span className="glyphicon glyphicon-alert fa-fw"> </span>
					SOMETHING WENT WRONG HERE
				</div>
				<div className="report-box-text">
					We couldn't determine the licenses for the dependencies you are currently using. It
					might be a temporary issue with our servers or the external service we are using.
					Please trying again in a few minutes, and if the problem persists please contact
					<a href="mailto:support@meterian.com">Meterian support</a> and we'll have a look
					for you.
				</div>
			</div>
		)
	}



	render() {

		const Title = () => {
			const atleastOneIsSelected = this.state.selectedSummaryLicenses.length > 0
			const excludeLicenses = () => {
				if(!atleastOneIsSelected) return
				try {
					this.props.newMitigations("mitigated", this.state.selectedSummaryLicenses, false, true)
				} catch(e) {
					console.log(e)
				}
			}
			return <>
				<h3 className="d-inline report-header mb-0" >
					<span name="licenses-assessment">
						<i className="fa fa-book" style={{ color: "gray" }} ></i> LICENSING ASSESSMENT
					</span>
				</h3>
				<i tabIndex={0} id="licensing-minimizer" className={(this.props.collapsed ? "fa-plus-square" : "fa-minus-square") + " far fa-lg section-minimizer ml-2 mt-0"} onClick={() => this.props.collapse(this.props.collapsed)} onKeyUp={(e) => { if (e.key.toLocaleLowerCase() === "enter") this.props.collapse(this.props.collapsed) }}></i>
				<DownloadLicensesCSV/>
				{ this.props.collapsed && !this.props.isPublic ? <span className='ml-2 mb-0'>
					<button className="btn btn-default" type="button" id="collapsed-licenses-action" data-toggle="dropdown" aria-haspopup="true">
						<span className="fas fa-ellipsis-v"></span>
					</button>
					<ul className="dropdown-menu dropdown-menu-left actions-dropdown-menu">
						<li data-action={"collapsed-exclude"} className={`action dropdown-item ${!atleastOneIsSelected ? "disabled": null}`} onClick={excludeLicenses}>
							<a>Exclude</a>
						</li>
					</ul>
				</span>: null}
			</>
		}
		const Error = () => this.state.error ? this.showError : ""

		const ModeSwitch = () =>

			this.props.displayTeaser ? null :
				<span id="mode-switch" style={{ marginTop: "-10px" }} className="btn btn-link pointer float-right"
					tabIndex={0}
					onClick={this.switchMode}
					onKeyUp={(e) => { if (e.key.toLowerCase() !== "enter") return; this.switchMode() }}>(switch view mode)
				</span>
			
	
		const Sorter = () => (!this.state.legal ?
			<span id="sort-licenses" style={{ marginTop: "-10px" }} className="btn btn-link pointer float-right"
				tabIndex={0}
				onClick={() => { this.switchSort() }}
				onKeyUp={(e) => { if (e.key.toLowerCase() !== "enter") return; this.switchSort() }}>{this.state.sortByRisk ? "(sort by name)" : "(sort by risk level)"}</span>
			: "")

		const TitleActionsPanel = () => (
			this.props.collapsed ? "" :
				<React.Fragment>
					<Sorter />
					<ModeSwitch />
				</React.Fragment>
		)


		const Summary = () => {
			if (!this.props.collapsed) return ""
			return this.generateSummaryData() || ""
		}

		const List = () => (
			this.state.legal ?
				<div id="licenses-group-legal">
					{
						!this.props.collapsed ?
							<LegalView licensing={this.props.licensing}
								findDependencyInTree={this.props.findDependencyInTree} isAccountDefault={this.props.isAccountDefault} />
							:
							null
					}
				</div>
				:
				<div id="licenses-group-standard">
					{
						!this.props.collapsed ?
							<StandardView licensing={this.props.licensing}
								displayActions={this.props.displayActions} isLatest={this.props.isLatest} findDependencyInTree={this.props.findDependencyInTree}
								isAccountDefault={this.props.isAccountDefault} removeMitigation={this.props.removeMitigation} setLocationsInfo={this.props.setLocationsInfo}
								newMitigations={this.props.newMitigations} isUserAdmin={this.props.isUserAdmin} setCopyrightLicense={this.props.setCopyrightLicense} setLicenseToFix={this.props.setLicenseToFix}
								sortByRisk={this.state.sortByRisk} removeData={this.removeData} librariesData={this.librariesData} teaser={this.props.displayTeaser} />
							:
							null
					}
				</div>
		)



		if (!this.state.ready) return null
		if (!this.props.display) return null
		if (!this.props.displayLicenses) return null;

		this.renderId = this.props.renderId;

		return (
			<div className="row" id="licenses-row">
				<div className="pb-3 col-lg-12">&nbsp;</div>
				<div className="col-md-12">
					<div className="mb-2">
						<Title />
						<TitleActionsPanel />
					</div>
					<Error />
					<Summary />
					<List />
				</div>
			</div>
		)
	}
}

export default connect(mapStateAsProps, mapDispatchAsProps)(Licensing);